import { render } from "./UserSecureAction.vue?vue&type=template&id=5c2e4bbe"
import script from "./UserSecureAction.vue?vue&type=script&lang=js"
export * from "./UserSecureAction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__